import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

window.__KEYCLOAK_INITIAL_HASH__ = window.location.hash;

(window as any).APP_CONFIG = {
    project: environment?.project,
    blackListedHosts: environment?.blackListedHosts,
};

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
